import {SyntheticEvent} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Maybe} from '../../../graphql/generated/types';
import {
  MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
  MOBILE_CONTENT_HOME_HEADER_ID,
  MOBILE_HEADER_HEIGHT_PX,
} from '../../../header/constants';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';

export interface MobileContentHomeHeaderProps {
  isLikeActive?: Maybe<boolean>;
  onClickLike?: (parameters?: {fromSavedCommand?: boolean}) => void;
  isAlarmActive?: Maybe<boolean>;
  onClickAlarm?: () => void;
  onClickMore?: () => void;
  onClickBack?: (e: SyntheticEvent) => void;
  onClickHome?: (e: SyntheticEvent) => void;
  showLikeAndAlarmArea: boolean;
  seriesId: number;
  isDarkMode: boolean;
  // 7차 스펙 콘텐츠홈 상단 그라데이션이 들어가면서 static 아이콘을 사용하지만, 본인인증 같은 콘텐츠홈 진입 전은 다크모드 대응 아이콘을 사용합니다.
  isHeaderIconStatic?: boolean;
}

export function MobileContentHomeHeader({
  isLikeActive,
  isAlarmActive,
  onClickAlarm,
  onClickLike,
  onClickMore,
  onClickHome,
  onClickBack,
  showLikeAndAlarmArea,
  isDarkMode,
  seriesId,
  isHeaderIconStatic,
}: MobileContentHomeHeaderProps) {
  return (
    <div
      id={MOBILE_CONTENT_HOME_HEADER_ID}
      className="flex w-full items-center justify-between bg-transparent px-18pxr"
      style={{
        height: MOBILE_HEADER_HEIGHT_PX,
      }}
    >
      <div className="flex">
        <Icon
          className={twMerge(
            MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
            'use-gpu',
            isDarkMode && 'filter-none!'
          )}
          type={
            isHeaderIconStatic
              ? IconType.NavigationBackStatic
              : IconType.NavigationBack
          }
          onClick={onClickBack}
        />
        <Icon
          type={
            isHeaderIconStatic
              ? IconType.NavigationHomeMwStatic
              : IconType.NavigationHomeMw
          }
          className={twMerge(
            'ml-16pxr',
            MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
            'use-gpu',
            isDarkMode && 'filter-none!'
          )}
          {...putTiaraObjectProps({
            eventMeta: {
              id: `kakaopage://open/content?series_id=${seriesId}`,
              type: 'scheme',
            },
          })}
          onClick={onClickHome}
        />
      </div>
      <div className="flex justify-end">
        {showLikeAndAlarmArea && (
          <>
            <Icon
              type={
                isHeaderIconStatic
                  ? isLikeActive
                    ? IconType.NavigationHeartOnStatic
                    : IconType.NavigationHeartOffStatic
                  : isLikeActive
                    ? IconType.NavigationHeartOn
                    : IconType.NavigationHeartOff
              }
              className={twMerge(
                'mr-16pxr',
                'use-gpu',
                MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
                isDarkMode && 'filter-none!'
              )}
              {...putTiaraObjectProps({
                click: {
                  copy: `좋아요${isLikeActive ? 'off' : 'on'}`,
                },
              })}
              onClick={e =>
                LOG_CLICK_EVENT('좋아요_클릭', e, () => onClickLike?.())
              }
            />
            {isLikeActive && (
              <Icon
                type={
                  isHeaderIconStatic
                    ? isAlarmActive
                      ? IconType.NavigationAlarmOnStatic
                      : IconType.NavigationAlarmOffStatic
                    : isAlarmActive
                      ? IconType.NavigationAlarmOn
                      : IconType.NavigationAlarmOff
                }
                className={twMerge(
                  'mr-16pxr',
                  'use-gpu',
                  MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
                  isDarkMode && 'filter-none!'
                )}
                {...putTiaraObjectProps({
                  click: {
                    copy: `알림${isAlarmActive ? 'off' : 'on'}`,
                  },
                })}
                onClick={e => LOG_CLICK_EVENT('알림_클릭', e, onClickAlarm)}
              />
            )}
          </>
        )}
        <Icon
          className={twMerge(
            MOBILE_CONTENT_HOME_HEADER_ICON_CLASSNAME,
            isDarkMode && 'filter-none!',
            'use-gpu'
          )}
          type={
            isHeaderIconStatic
              ? IconType.NavigationMoreStatic
              : IconType.NavigationMore
          }
          onClick={e => LOG_CLICK_EVENT('더보기_클릭', e, onClickMore)}
        />
      </div>
    </div>
  );
}
